export enum SurveyStatsViewByEnum {
	Question = 'question',
	Family = 'family',
}

export const SurveyStatsViewByArray = [SurveyStatsViewByEnum.Question, SurveyStatsViewByEnum.Family];
